module.exports = __webpack_public_path__ + "img/shopee.f290852b.svg";